import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export function apiDeleteSavedConfig(configCode: string): Promise<boolean> {
  return occFetch(occUrl(`/saved-configs/${configCode}`), {
    method: "DELETE",
  })
    .then((result) => {
      if (result.ok) {
        return true;
      } else {
        console.error(`Error sending linear update: ${result.status}`);
        return false;
      }
    })
    .catch((err) => {
      console.error(err);
      return false;
    });
}
